import React from 'react';
import Modal from 'antd/lib/modal';
import { CheckCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const CustomModal = (
  title,
  content,
  okHandler,
  cancelHandler,
  okText,
  cancelText,
) => {
  confirm({
    title: title,
    icon: <CheckCircleOutlined />,
    content: content,
    okText: okText ? okText : 'Close',
    cancelText: cancelText ? cancelText : 'Onboard now',
    onOk() {
      okHandler();
    },
    onCancel() {
      cancelHandler();
    },
  });
};

export default CustomModal;
